import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
declare let $: any;
declare var bootstrap: any; // global from bootstrap.bundle.min.js
@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss']
})
export class HeaderMenuComponent implements OnInit, AfterViewInit {
  screenWidth: number = window.innerWidth;
constructor(private router: Router) {}

ngOnInit(): void {
  this.router.events.subscribe((event) => {
    if (event instanceof NavigationEnd) {
      // Collapse all dropdowns
      const dropdowns = document.querySelectorAll('.dropdown');
      dropdowns.forEach(dropdown => dropdown.classList.remove('show'));

      const dropdownMenus = document.querySelectorAll('.dropdown-menu');
      dropdownMenus.forEach(menu => menu.classList.remove('show'));

      // Collapse navbar (mobile)
      const navbarCollapse = document.querySelector('.navbar-collapse');
      navbarCollapse?.classList.remove('show');
    }
  });
}


  ngAfterViewInit(){
        const dropdownToggle = document.getElementById('dropdownMenuButton1');
    if (dropdownToggle) {
      new bootstrap.Dropdown(dropdownToggle);
    }
    // window.onscroll = function() {
    //   var header1 = document.querySelector(".navbar-area");
    //   var sticky = header1.offsetTop;
    //   if (window.pageYOffset > sticky) {
    //     header1.classList.add("sticky");
    //   } else {
    //     header1.classList.remove("sticky");
    //   }
    // };
    /*---------------------------
    :: Academics top
    -----------------------------*/

    // $(document).ready(() => {
    //   $('.accordion').on('click touchstart', () => {
    //     var collapseTarget = $($(this).data('bs-target'));

    //     // Check if the target is already shown
    //     var isCollapsed = collapseTarget.hasClass('show');

    //     // Hide all other shown accordion items
    //     $('.accordion-collapse.show').not(collapseTarget).removeClass('show');

    //     // Toggle the target accordion item
    //     if (!isCollapsed) {
    //       collapseTarget.addClass('show');
    //     } else {
    //       collapseTarget.removeClass('show');
    //     }
    //   });

    //   var selector = '.academics-list li a';

    //   $(selector).on('click', () => {
    //     // Remove 'active' class from all items
    //     $(selector).removeClass('active');
    //     // Add 'active' class to the clicked item
    //     $(this).addClass('active');
    //   });
    // });
  }
}
